import * as React from 'react'
import { Text, Colors } from '@doordash/design-language'
import ListCell from '@doordash/component-list-cell'

export const IconListCell = ({ icon, string, color = Colors.SystemBlack }) => (
  <ListCell
    iconStart={{ type: icon, color }}
    iconAlignment={ListCell.Alignment.FlexStart}
    isSubtextFirst
    isSquished
    isSeparatorVisible={false}
    subtextMaxLines={10}
    subtext={<Text color={Colors.SystemGrey80}>{string}</Text>}
    insetSize={ListCell.InsetSizes.None}
  />
)
